import { jsx as _jsx } from "react/jsx-runtime";
import Logotype from "../Logotype/Logotype";
import { EAppId } from "@timeedit/types/lib/enums";
import { APP_ID_TO_NAME_MAP } from "@timeedit/types/lib/enums/appIds.enum";
export const PRODUCTS_MAP = {
    TE_CURRICULUM: {
        product: EAppId.TE_CURRICULUM,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_CURRICULUM],
        icon: (size) => (_jsx(Logotype, { alt: "Curriculum", id: "Curriculum", size: size })),
        href: "curriculum",
        openNewTab: false
    },
    TE_PLAN: {
        product: EAppId.TE_PLAN,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_PLAN],
        icon: (size) => _jsx(Logotype, { alt: "Plan", id: "Plan", size: size }),
        href: "plan",
        openNewTab: true
    },
    TE_ALLOCATE: {
        product: EAppId.TE_ALLOCATE,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_ALLOCATE],
        icon: (size) => (_jsx(Logotype, { alt: "Allocate", id: "Allocate", size: size })),
        href: "allocate",
        openNewTab: false
    },
    TE_CORE: {
        product: EAppId.TE_CORE,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_CORE],
        icon: (size) => _jsx(Logotype, { alt: "Core", id: "Core", size: size }),
        href: "core",
        openNewTab: true
    },
    TE_DATA_MANAGER: {
        product: EAppId.TE_DATA_MANAGER,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_DATA_MANAGER],
        icon: (size) => (_jsx(Logotype, { alt: "Data Manager", id: "DataManager", size: size })),
        href: "data-manager",
        openNewTab: false
    },
    TE_EXAM: {
        product: EAppId.TE_EXAM,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_EXAM],
        icon: (size) => _jsx(Logotype, { alt: "Exam", id: "Exam", size: size }),
        href: "exam",
        openNewTab: true
    },
    TE_EXAM_V3: {
        product: EAppId.TE_EXAM_V3,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_EXAM],
        icon: (size) => _jsx(Logotype, { alt: "Exam", id: "Exam", size: size }),
        href: "exam",
        openNewTab: true
    },
    TE_PREFERENCES: {
        product: EAppId.TE_PREFERENCES,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_PREFERENCES],
        icon: (size) => (_jsx(Logotype, { alt: "Preferences", id: "Preferences", size: size })),
        href: "preferences",
        openNewTab: false
    },
    TE_RESERVE: {
        product: EAppId.TE_RESERVE,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_RESERVE],
        icon: (size) => (_jsx(Logotype, { alt: "Reserve", id: "Reserve", size: size })),
        href: "reserve",
        openNewTab: true
    },
    TE_REGISTRATION: {
        product: EAppId.TE_REGISTRATION,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_REGISTRATION],
        icon: (size) => (_jsx(Logotype, { alt: "Registration", id: "Registration", size: size })),
        href: "registration",
        openNewTab: true,
        hidden: true
    },
    TE_STUDY_GUIDE: {
        product: EAppId.TE_STUDY_GUIDE,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_STUDY_GUIDE],
        icon: (size) => (_jsx(Logotype, { alt: "Study Guide", id: "StudyGuide", size: size })),
        href: "study-guide",
        openNewTab: true
    },
    TE_STUDY_PLANNER: {
        product: EAppId.TE_STUDY_PLANNER,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_STUDY_PLANNER],
        icon: (size) => (_jsx(Logotype, { alt: "Study Planner", id: "StudyPlanner", size: size })),
        href: "studyplanner",
        openNewTab: true
    },
    TE_VIEWER: {
        product: EAppId.TE_VIEWER,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_VIEWER],
        icon: (size) => (_jsx(Logotype, { alt: "Viewer", id: "Viewer", size: size })),
        href: "viewer",
        openNewTab: true
    },
    TE_EVALUATION: {
        product: EAppId.TE_EVALUATION,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_EVALUATION],
        icon: (size) => (_jsx(Logotype, { alt: "Evaluation", id: "Evaluation", size: size })),
        href: "evaluation",
        openNewTab: false
    },
    TE_REPORTING: {
        product: EAppId.TE_REPORTING,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_REPORTING],
        icon: (size) => (_jsx(Logotype, { alt: "Reporting", id: "Reporting", size: size })),
        href: "reporting",
        openNewTab: true
    },
    TE_ADMIN: {
        product: EAppId.TE_ADMIN,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_ADMIN],
        icon: (size) => (_jsx(Logotype, { alt: "Admin", id: "Admin", size: size })),
        href: "admin",
        openNewTab: false
    },
    TE_PORTAL: {
        product: EAppId.TE_PORTAL,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_PORTAL],
        icon: (size) => _jsx(Logotype, { alt: "Portal", id: "TE", size: size }),
        href: "portal",
        openNewTab: true
    },
    TE_HUB: {
        product: EAppId.TE_HUB,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_HUB],
        icon: (size) => _jsx(Logotype, { alt: "Hub", id: "TE", size: size }),
        href: "hub",
        openNewTab: true,
        hidden: true
    },
    TE_ACTIVITIES: {
        product: EAppId.TE_ACTIVITIES,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_ACTIVITIES],
        href: "activities",
        openNewTab: true
    },
    TE_AM: {
        product: EAppId.TE_AM,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_AM],
        href: "activity-manager",
        openNewTab: true,
        hidden: true
    },
    TE_AUTOPILOT: {
        product: EAppId.TE_AUTOPILOT,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_AUTOPILOT],
        icon: (size) => (_jsx(Logotype, { alt: "Autopilot", id: "Autopilot", size: size })),
        href: "autopilot",
        openNewTab: true,
        hidden: true
    },
    TE_DEBIT: {
        product: EAppId.TE_DEBIT,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_DEBIT],
        href: "debit",
        openNewTab: true,
        hidden: true
    },
    TE_REST: {
        product: EAppId.TE_REST,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_REST],
        href: "rest",
        openNewTab: true,
        hidden: true
    },
    TE_SEAT_MANAGEMENT: {
        product: EAppId.TE_SEAT_MANAGEMENT,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_SEAT_MANAGEMENT],
        href: "seat-management",
        openNewTab: true,
        hidden: true
    },
    TE_SERVER_THREAD: {
        product: EAppId.TE_SERVER_THREAD,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_SERVER_THREAD],
        href: "server-thread",
        openNewTab: true,
        hidden: true
    },
    TE_SOAP: {
        product: EAppId.TE_SOAP,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_SOAP],
        href: "soap",
        openNewTab: true,
        hidden: true
    },
    TE_STATISTICS: {
        product: EAppId.TE_STATISTICS,
        label: APP_ID_TO_NAME_MAP[EAppId.TE_STATISTICS],
        href: "statistics",
        openNewTab: true,
        hidden: true
    },
    JAVA_CLIENT: {
        product: EAppId.JAVA_CLIENT,
        label: APP_ID_TO_NAME_MAP[EAppId.JAVA_CLIENT],
        href: "java-client",
        openNewTab: true,
        hidden: true
    }
};
